import image1 from '@/assets/news/20211011_1.png'
import image2 from '@/assets/news/20211011_2.png'
import image3 from '@/assets/news/20211011_3.png'

export default {
  zh: {
    title: '国内首个合成基因线路精准调控的基因治疗产品 SynOV1.1 获得临床试验批件',
    abstract: '6月16日，2021年10月11日，北京合生基因科技有限公司研发的首款基因治疗产品——用于治疗晚期实体瘤的溶瘤病毒产品 SynOV1.1 腺病毒注射液获得国家药品监督管理局（NMPA）临床试验默示许可。',
    cover: image1,
    content: `
  <p>2021年10月11日，北京合生基因科技有限公司（以下简称合生基因）研发的首款基因治疗产品——用于治疗晚期实体瘤的溶瘤病毒产品 SynOV1.1 腺病毒注射液获得国家药品监督管理局（NMPA）临床试验默示许可，这也是国内首个“合成基因线路精准调控”的基因治疗产品获得国家药监局批准开展临床试验。</p>
  <div style="text-align:center"><img src="${image1}"></img></div>
  <h3>关于 SynOV1.1</h3>
  <p>SynOV1.1 是合生基因基于“基因线路调控溶瘤腺病毒平台（SynOV）”开发的第一款产品。SynOV1.1 利用由甲胎蛋白（AFP）启动子和微小 RNA（microRNA）组成的合成基因线路，控制溶瘤腺病毒在AFP阳性的肿瘤细胞中特异性复制,溶解肿瘤。与既往溶瘤病毒产品相比，SynOV1.1 复制由基因线路调控，靶向性更强，药物安全窗口更大，治疗效果得到显著提高。在此之前，该产品已于 2020 年 11 月获得美国 FDA 临床试验许可。</p>
  <div style="text-align:center"><img src="${image2}"></img></div>
  <h3>关于合成基因线路</h3>
  <p>合成基因线路是指由一些基本生物元件构成的人工基因网络，可在活细胞中感受、整合、处理分子信号，自动地执行特定的生物功能。装载合成基因线路的基因与细胞产品可以响应特定的疾病生物标志物或其他控制信号（光、热、声等），特异性靶向异常细胞和病灶区域、表达、释放治疗药物，使治疗更智能、可控。合成基因线路将引领新一代基因与细胞疗法的开发。</p>
  <div style="text-align:center"><img src="${image3}"></img></div>
  <h3>关于合生基因</h3>
  <p>合生基因作为中国首家致力于合成生物技术在生物医药领域应用的高新技术企业，于 2014 年成立于中关村生命科学园。合生基因期望利用合成生物技术开发针对癌症、遗传病、传染性疾病的创新药物和治疗方法，构建基于合成生物技术的生物医药新生态。通过合理设计构建新型基因、免疫细胞和 RNA 核酸药物，提高药物研发成功率、有效性和安全性。值得关注的是，合生基因持续加码布局以合成生物技术为基础的下一代生物药物智能制造平台开发，在合成医学生物学方向处于国际领先水平。</p>
    `
  }
}
